import { render, staticRenderFns } from "./PagesForm.vue?vue&type=template&id=2b9a1f9a"
import script from "./PagesForm.vue?vue&type=script&lang=js"
export * from "./PagesForm.vue?vue&type=script&lang=js"
import style0 from "./PagesForm.vue?vue&type=style&index=0&id=2b9a1f9a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9a1f9a')) {
      api.createRecord('2b9a1f9a', component.options)
    } else {
      api.reload('2b9a1f9a', component.options)
    }
    module.hot.accept("./PagesForm.vue?vue&type=template&id=2b9a1f9a", function () {
      api.rerender('2b9a1f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/PagesForm.vue"
export default component.exports